import { isEmpty } from 'lodash';

const getTalkingPointStatusesResponse = (response) => {
  if (isEmpty(response?.data?.briefStatuses)) return [];

  const briefStatuses = response.data.briefStatuses.map((briefStatus) => {
    return {
      value: briefStatus?.key,
      label: briefStatus?.label,
    };
  });

  return briefStatuses;
};

export default getTalkingPointStatusesResponse;
